import { render, staticRenderFns } from "./CustodyExpenseOperationAdd.vue?vue&type=template&id=4b9a8f62&"
import script from "./CustodyExpenseOperationAdd.vue?vue&type=script&lang=js&"
export * from "./CustodyExpenseOperationAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports